import { InjectionToken, Provider } from '@angular/core';
import * as config from '../config';

export type AppConfig = typeof config;

export const AppConfig = new InjectionToken<typeof config>('AppConfig', { providedIn: 'root', factory: () => config });

export const AppConfigProvider: Provider = { provide: AppConfig, useValue: config };
